var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownX2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9708 21.5197C10.3962 22.0489 9.41708 22.2862 8.61455 21.7112C7.58966 20.9768 6.96682 19.8941 7.0377 18.5052C7.0812 17.6528 7.38357 16.7389 7.92626 15.7639L5.33525 15.7639C3.51879 15.7639 2.11906 14.1624 2.36226 12.3623L3.37741 4.84823C3.57845 3.36012 4.84877 2.24988 6.3504 2.24988L20.0469 2.24988C21.1514 2.24988 22.0469 3.14531 22.0469 4.24988L22.0469 14.2499C22.0469 15.3545 21.1514 16.2499 20.0469 16.2499L16.6927 16.2499L10.9708 21.5197ZM16.0469 14.1257L9.66771 20.0008C9.21287 19.6361 9.00496 19.1978 9.0351 18.6072C9.07186 17.8868 9.47204 16.8271 10.5828 15.3702C10.8134 15.0679 10.8525 14.661 10.6838 14.3203C10.5151 13.9795 10.1678 13.7639 9.78762 13.7639L5.33525 13.7639C4.72976 13.7639 4.26318 13.2301 4.34425 12.63L5.3594 5.116C5.42642 4.61996 5.84986 4.24988 6.3504 4.24988L16.0469 4.24988L16.0469 14.1257ZM18.0469 4.24988L18.0469 14.2499L20.0469 14.2499L20.0469 4.24988L18.0469 4.24988ZM9.6134 20.0504L9.61461 20.0496L9.6134 20.0504Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownX2);
export default __webpack_public_path__ + "static/media/ThumbsDownX2.040775bd628b003ca1dad662efa8e367.svg";
export { ForwardRef as ReactComponent };